import { ProductSolrDTO } from "./product-solr";
import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { ProductType } from '@signature-it/ngx-catalogue/classes';
import {ProductFullSolrDTO} from "./product-full-solr";
import { GenericConfig } from '@signature-it/ngx-generic/config';

export class SolrDocsDTO extends AbstractDTO {

    _products: Array<ProductSolrDTO>;

    numFound: number;
    start: number;
    isFamily: boolean;
    isBucket: boolean;
    taxonomy: string;
    leafNodeUri: string;
    ProductClassDTO: any;
    currentNodeUri: string;

    constructor(attributes?: object , ProductClassDTO?) {
        super(attributes);
        attributes = attributes || {};

        this.ProductClassDTO = ProductClassDTO;
        if(!ProductClassDTO && GenericConfig.useProductFullSolrDTO) {
            this.ProductClassDTO = ProductFullSolrDTO;
        }
        this.taxonomy = attributes['taxonomy'] || '';
        this.leafNodeUri = attributes['leafNodeUri'] || '';
        this.currentNodeUri = attributes['currentNodeUri'] || '';
        this.products = attributes['docs'];
        this.numFound = attributes['numFound'] || 0;
        this.start = attributes['start'] || 0;
        this.isFamily = attributes['numFound'] > 1 && this.products[0].productType !== ProductType.SKU;
        this.isBucket = attributes['numFound'] > 1 && this.products[0].productType === ProductType.SKU;
    }

    set products(value) {
        value = this.taxonomy ? value.map(v => {
            v.taxonomy = this.taxonomy;
            v.leafNodeUri = this.leafNodeUri;
            v.currentNodeUri = this.currentNodeUri;
            return v;
        }) : value;
        this._products =  this.ProductClassDTO ? this.ProductClassDTO.createFromArray(value) : ProductSolrDTO.createFromArray(value);
    }

    get products() {
        return this._products;
    }

}
